import { Routes } from '@angular/router';
var routes = [
    { path: 'general', redirectTo: 'course', pathMatch: 'full' },
    { path: '', redirectTo: 'course', pathMatch: 'full' },
    { path: 'course', loadChildren: './course/course.module#CourseModule' },
    { path: 'onsite-lector', loadChildren: './onsite-lector/onsite-lector.module#OnsiteLectorModule' },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
